import { render, staticRenderFns } from "./ImportarExportarCadastros.vue?vue&type=template&id=06952a48"
import script from "./ImportarExportarCadastros.vue?vue&type=script&lang=js"
export * from "./ImportarExportarCadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports